export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8341.cd9080af.jpg";